import { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import cc from 'classcat';
import noScroll from 'no-scroll';

import { themes } from '../../lib/themes';
import Link from '../Link';
import { To, BREAKPOINTS } from '../Responsive';

import styles from './styles.module.scss';

class ProfileMenu extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    product: PropTypes.oneOf(themes),
    onClose: PropTypes.func,
  };
  static defaultProps = {
    product: 'waybetter',
    onClose: () => {},
  };
  static displayName = 'ProfileMenu';

  state = {
    viewportWidth: 0,
  };

  constructor(props) {
    super(props);

    this.state.viewportWidth = window.innerWidth;
  }

  updateHeight = () => {
    const viewportWidth = window.innerWidth;
    this.setState({ viewportWidth });

    if (window.innerWidth <= BREAKPOINTS[1]) {
      noScroll.on();
    } else {
      noScroll.off();
    }
  };

  handleClose = () => this.props.onClose();

  preventBubble(event) {
    event.stopPropagation();
  }

  componentDidMount() {
    this.updateHeight();
    window.addEventListener('resize', this.updateHeight);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateHeight);
    noScroll.off();
  }

  render() {
    const { product, name, className } = this.props;
    const { handleClose } = this.state;
    const menu = (
      <ul
        onMouseLeave={handleClose}
        onClick={handleClose}
        className={cc([styles.container, className])}
      >
        <li className={styles.nameItem} onClick={this.preventBubble}>
          <span className={styles.name}>{name}</span>
        </li>
        <li>
          <Link
            theme="none"
            to={`/logout?product=${product}`}
            className={styles.link}
            onClick={handleClose}
          >
            Log out
          </Link>
        </li>
      </ul>
    );

    return (
      <To slice={1}>
        {(matches) =>
          matches ? ReactDOM.createPortal(menu, document.body) : menu
        }
      </To>
    );
  }
}

export default ProfileMenu;
